import { create } from "zustand";
import { today, getLocalTimeZone } from "@internationalized/date";

const defaultStore = {
  showPicker: false,
  isDefault: true,
  // 1, 2, 3, 4-9, 10-25, 26+
  // From 10-25 other rows are hidden
  rooms: 1,
  roomsText: "1",
  guests: 1, // max 8
  adults: 1,
  // Array of numbers from 0 to 17, where 0 - age <1
  children: [],
  // Default date range
  dateRange: {
    start: today(getLocalTimeZone()),
    end: today(getLocalTimeZone()).add({ days: 3 })
  },
  formattedStartDate: "",
  formattedEndDate: "",
  searchDestination: "", // Destination name for search input
};

export const useSearchStore = create((set) => ({
  ...defaultStore,

  toggle: () => set((state) => ({ showPicker: !state.showPicker })),
  reset: () =>
    set((state) => ({
      ...defaultStore,
      showPicker: state.showPicker,
    })),

  setDateRange: (range) => {
    const formattedStartDate =
      range.start && range.start.year && range.start.month && range.start.day
        ? `${range.start.month}/${range.start.day}/${range.start.year}`
        : "";
    const formattedEndDate =
      range.end && range.end.year && range.end.month && range.end.day
        ? `${range.end.month}/${range.end.day}/${range.end.year}`
        : "";

    set(() => ({
      dateRange: range,
      formattedStartDate,
      formattedEndDate,
    }));
  },
  setRooms: (rooms) =>
    set((state) => ({
      rooms,
      roomsText: {
        1: "1",
        2: "2",
        3: "3",
        4: "4-9",
        5: "10-25",
        6: "26+",
      }[rooms],
      isDefault: rooms === 1 && state.adults === 1 && !state.children.length,
    })),
  setAdults: (adults) =>
    set((state) => ({
      adults,
      guests: state.guests - state.adults + adults,
      isDefault: state.rooms === 1 && adults === 1 && !state.children.length,
    })),
  setChildren: (children) =>
    set((state) => ({
      children,
      guests: state.guests - state.children.length + children.length,
      isDefault: state.rooms === 1 && state.adults === 1 && !children.length,
    })),
  setSearchDestination: (destination) =>
    set(() => ({
      searchDestination: destination,
    })),
}));
